import React from 'react';

export default function PageContainer({ children, className = '' }) {
  return (
    <section className={`px-6 sm:px-10 lg:px-16 xl:px-24 py-14 lg:py-20 ${className}`}>{children}</section>
  );
}
